import { environment } from "src/environments/environment";

export class Utils {
  static notRepetSearch(caracter: string, search: string) {
    let i = 0;
    let counter = 0;
    while (i !== -1) {
         i = caracter.indexOf(search, i);
         if (i !== -1) {
            i++;
            counter++;
        }
    }
    return counter;
  };
}

export function tokenGetter() {
  const token = localStorage.getItem(environment.TOKEN_NAME);
  return token;
}